const data = {
  'Selected': 'Valgt: {0} af {1}',
  'Uploading files': 'Uploader {0}% af {1}',
  'File size error': '{0} er for stor, upload venligst filer mindre end {1}',
  'Upload failed': '{0} kunne ikke uploades',
  'Per page': '{0} pr. side',
  'Folder': 'Mappe',
  'Login failed, please try again': 'Login mislykkedes, prøv venligst igen',
  'Already logged in': 'Allerede logget ind.',
  'Please enter username and password': 'Indtast venligst brugernavn og adgangskode.',
  'Not Found': 'Ikke fundet',
  'Not Allowed': 'Ikke tilladt',
  'Please log in': 'Log venligst ind',
  'Unknown error': 'Ukendt fejl',
  'Add files': 'Tilføj filer',
  'New': 'Ny',
  'New name': 'Nyt navn',
  'Username': 'Brugernavn',
  'Password': 'Adgangskode',
  'Login': 'Log ind',
  'Logout': 'Log ud',
  'Profile': 'Profil',
  'No pagination': 'Ingen sideinddeling',
  'Time': 'Tidspunkt',
  'Name': 'Navn',
  'Size': 'Størrelse',
  'Home': 'Hjem',
  'Copy': 'Kopiér',
  'Move': 'Flyt',
  'Rename': 'Omdøb',
  'Required': 'Udfyld venligst dette felt',
  'Zip': 'Zip',
  'Batch Download': 'Download flere',
  'Unzip': 'Udpak',
  'Delete': 'Slet',
  'Download': 'Download',
  'Copy link': 'Kopiér link',
  'Done': 'Færdig',
  'File': 'Fil',
  'Drop files to upload': 'Slip filer her for at uploade',
  'Close': 'Luk',
  'Select Folder': 'Vælg mappe',
  'Users': 'Brugere',
  'Files': 'Filer',
  'Role': 'Rolle',
  'Cancel': 'Annuller',
  'Paused': 'På pause',
  'Confirm': 'Bekræft',
  'Create': 'Opret',
  'User': 'Bruger',
  'Admin': 'Admin',
  'Save': 'Gem',
  'Read': 'Læse',
  'Write': 'Skrive',
  'Upload': 'Upload',
  'Permissions': 'Rettigheder',
  'Homedir': 'Hjemmemappe',
  'Leave blank for no change': 'Lad feltet stå tomt for at undgå ændringer',
  'Are you sure you want to do this?': 'Er du sikker på, at du vil gøre dette?',
  'Are you sure you want to allow access to everyone?': 'Er du sikker på, at du vil give alle adgang?',
  'Are you sure you want to stop all uploads?': 'Er du sikker på, at du vil stoppe alle uploads?',
  'Something went wrong': 'Noget gik galt',
  'Invalid directory': 'Ugyldig mappe',
  'This field is required': 'Dette felt er påkrævet',
  'Username already taken': 'Brugernavnet er allerede taget',
  'User not found': 'Brugeren blev ikke fundet',
  'Old password': 'Gammel adgangskode',
  'New password': 'Ny adgangskode',
  'Wrong password': 'Forkert adgangskode',
  'Updated': 'Opdateret',
  'Deleted': 'Slettet',
  'Your file is ready': 'Din fil er klar',
  'View': 'Vis',
  'Search': 'Søg',
  'Download permission': 'Download',
  'Guest': 'Gæst',
  'Show hidden': 'Vis skjulte',
  'Show symbolic format': 'Vis symbolsk format',
  'Hide symbolic format': 'Skjul symbolsk format',
}

export default data
